export const visibleLevelOptions = [
  { value: 0, label: '转介人' },
  { value: 2, label: '新贵' },
  { value: 3, label: '精英' },
  { value: 4, label: '王者' },
  { value: 5, label: '合伙人' },
  { value: 6, label: '高级合伙人' }
];

export function getVisibleLevels(row) {
  const levels = Array.isArray(row.visibleLevelList)
    ? row.visibleLevelList
    : String(row.visibleLevels || '')
        .split(',')
        .filter(value => value.trim() !== '');
  return visibleLevelOptions.filter(item => levels.some(value => Number(value) === item.value)).map(item => item.value);
}

export function getFileType(file) {
  if (file.fileType) return file.fileType.replace(/^\./, '').toLowerCase();
  const path = (file.fileUrl || file.path || '').split(/[?#]/)[0];
  const extension = path.match(/\.([a-z0-9]+)$/i) || (file.fileName || '').match(/\.([a-z0-9]+)$/i);
  return extension ? extension[1].toLowerCase() : '';
}
